import React, { useRef } from "react";

import { Button, ButtonProps } from "..";
import { readXlsxFile } from "../../utils/functions";

export interface FilePickerProps {
  onChange?: (data: any) => void | any;
  inputStyle?: React.CSSProperties;
  title?: string;
  style?: React.CSSProperties;
  buttonCategory?: ButtonProps["category"];
}

export const FilePicker = ({
  inputStyle,
  onChange,
  style,
  title = "Selecciona un archivo",
  buttonCategory = "default",
}: FilePickerProps): JSX.Element => {
  const uploadInputRef = useRef(null);

  const handleUpload = async (e) => {
    e.preventDefault();

    const files = e.target.files;
    const file = files[0];

    const data = await readXlsxFile({ file });

    onChange && onChange(data);
  };

  return (
    <div style={style}>
      <input
        id="xlsx-file-input-id"
        value=""
        ref={uploadInputRef}
        type="file"
        onChange={handleUpload}
        accept=".xlsx, .csv"
        style={{ display: "none", ...inputStyle }}
      />

      <label htmlFor="icon-button-file">
        <Button
          category={buttonCategory}
          component="span"
          onClick={() =>
            uploadInputRef.current && uploadInputRef.current.click()
          }>
          {title}
        </Button>
      </label>
    </div>
  );
};
